/**
 * PARTNER_CONFIG
 * Centralized registry for all partner base URLs and social deep links.
 */
const PARTNER_CONFIG = {
  impactId: "3154823", // Replace with your actual Impact.com Member ID
  delivery: {
    ubereats: "https://www.ubereats.com/store/",
    doordash: "https://www.doordash.com/store/",
    instacart: "https://www.instacart.com/store/",
    shipt: "https://www.shipt.com/shop/retailer/"
  } as Record<string, string>,
  social: {
    facebook: {
      web: "https://www.facebook.com/nutrimap",
      app: "fb://page/nutrimap"
    },
    instagram: {
      web: "https://www.instagram.com/nutrimap",
      app: "instagram://user?username=nutrimap"
    },
    tiktok: {
      web: "https://www.tiktok.com/@nutrimap",
      app: "snssdk1233://user/profile/nutrimap" // Example TikTok scheme
    },
    snapchat: {
      web: "https://www.snapchat.com/add/nutrimap",
      app: "snapchat://add/nutrimap"
    }
  } as Record<string, { web: string; app: string }>
};

/**
 * handleRedirect
 * Checks current URL for ?go=[platform] and &id=[identifier] parameters.
 * Routes user to affiliate-wrapped partner links or native app schemes.
 */
export const handleRedirect = () => {
  const params = new URLSearchParams(window.location.search);
  const go = params.get('go');
  const id = params.get('id');

  if (!go) return false;

  // 1. Sanitize platform parameter to prevent injection/malicious redirects
  const platform = go.toLowerCase().trim().replace(/[^a-z0-9]/g, '');
  const identifier = id ? id.trim() : '';
  
  // 2. Determine if it's a delivery partner
  if (PARTNER_CONFIG.delivery[platform]) {
    const baseTarget = PARTNER_CONFIG.delivery[platform] + encodeURIComponent(identifier);
    
    // Wrap in Impact.com affiliate tracking link
    const affiliateUrl = `https://nutrimap-impact.net/c/${PARTNER_CONFIG.impactId}/?u=${encodeURIComponent(baseTarget)}`;
    
    window.location.href = affiliateUrl;
    return true;
  }

  // 3. Determine if it's a social partner
  if (PARTNER_CONFIG.social[platform]) {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const target = isMobile 
      ? PARTNER_CONFIG.social[platform].app 
      : PARTNER_CONFIG.social[platform].web;
      
    window.location.href = target;
    return true;
  }

  return false;
};

/**
 * createRedirectUrl
 * Helper to generate an internal app link that triggers the redirect system.
 */
export const createRedirectUrl = (platform: string, id: string = '') => {
  const url = new URL(window.location.origin + window.location.pathname);
  url.searchParams.set('go', platform);
  if (id) url.searchParams.set('id', id);
  return url.toString();
};
